import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { KeycloakService } from 'keycloak-angular';
import { BreadcrumbsComponent, IconComponent, PageHeaderComponent } from '@pansa/ui';

@Component({
  selector: 'rqa-dashboard',
  standalone: true,
  imports: [CommonModule, DatePipe, PageHeaderComponent, BreadcrumbsComponent, IconComponent, DatePipe],
  providers: [KeycloakService],
  styleUrl: './dashboard.component.scss',
  template: `
    <pui-page-header [title]="'Dashboard'">
      <pui-breadcrumbs>
        <a pui-breadcrumbs-item href="/">
          <pui-icon icon="home-line" />
        </a>
        <a pui-breadcrumbs-item href="/">Dashboard</a>
      </pui-breadcrumbs>
    </pui-page-header>
    <div class="d-flex p-3xl">
      <div class="date">
        <h2>Dzień dobry</h2>
        <div>Dzisiaj: {{ currentDate | date: 'long' : '' : 'pl' }}</div>
        <div>UTC: {{ currentDate | date: 'long' : 'UTC' : 'en' }}</div>
      </div>
    </div>
  `
})
export class DashboardComponent implements OnInit, OnDestroy {
  userName?: string;
  currentDate: Date = new Date();
  private timerId?: number;

  constructor(private readonly keycloak: KeycloakService, private readonly cdr: ChangeDetectorRef) { }

  async ngOnInit() {
    try {
      if (await this.keycloak.isLoggedIn()) {
        const profile = await this.keycloak.getKeycloakInstance().loadUserProfile();

        this.userName = profile.firstName ?? undefined;
      }
    } catch (error) {
      console.error('Error loading user profile:', error);
    }

    this.timerId = window.setInterval(() => {
      this.currentDate = new Date();
      this.cdr.markForCheck();
    }, 1000);
  }

  ngOnDestroy() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  }
}
